import { schema } from 'normalizr';

export const impactAssessmentThresholdSchema = new schema.Entity(
  'impactAssessmentThresholds',
  {},
  { idAttribute: 'ImpactAssessmentThresholdId' },
);
export const impactAssessmentThresholdListSchema = [impactAssessmentThresholdSchema];
